import { Divider, Flex, Text } from '@chakra-ui/react';
import { useMemo } from 'react';
import RowList from '../../nesting/RowList';
import { TeamDto } from '../../types/team-table.types';
import { useTeamTableContext } from '../../context/TeamTableContext';

const findLastVisibleName = (
  rows: TeamDto[],
  expanded: string[]
): string | undefined => {
  let last: string | undefined;

  rows.forEach((row) => {
    last = row.name;

    if (
      row.subTeams &&
      row.subTeams.length > 0 &&
      expanded.includes(row.name)
    ) {
      const childLast = findLastVisibleName(
        row.subTeams as unknown as TeamDto[],
        expanded
      );
      if (childLast) {
        last = childLast;
      }
    }
  });

  return last;
};

export default function NestingDropdown({
  data,
  isLoading,
}: {
  data: TeamDto[];
  isLoading: boolean;
}) {
  const { expanded } = useTeamTableContext();

  const lastVisibleName = useMemo(
    () => findLastVisibleName(data || [], expanded || []),
    [data, expanded]
  );
  return (
    <Flex
      direction="column"
      position="sticky"
      left={0}
      bg="white"
      h={'fit-content'}
      minW="30px"
      zIndex={100}
    >
      <Flex
        bg="#FBFBFB"
        position="sticky"
        top={0}
        borderLeft="1px solid #E0E0E0"
        align="center"
        minH="52px"
        px={4}
        zIndex={50}
      >
        <Flex w="full" align="center" justify={'center'}>
          <Flex w="full" cursor={'pointer'} gap={1} align="center">
            <Text
              fontSize="sm"
              fontFamily="heading"
              fontWeight="medium"
              color="text.secondary2"
              w="fit-content"
            ></Text>
          </Flex>
        </Flex>
      </Flex>
      <Divider />

      {!isLoading && (
        <RowList
          level={0}
          key="DROPDOWN"
          colKey="DROPDOWN"
          rows={data}
          lastVisibleName={lastVisibleName}
        />
      )}

      <Divider />
    </Flex>
  );
}
